(() => {
  const root = document.querySelector('[data-powdi-blog]');
  if (!root) return;

  const tags = root.querySelector('[data-blog-tags]');
  const tagsNext = root.querySelector('[data-blog-tags-next]');
  if (tags && tagsNext) {
    const updateTagsOverflow = () => {
      const overflow = tags.scrollWidth - tags.clientWidth > 8;
      const atEnd = tags.scrollLeft + tags.clientWidth >= tags.scrollWidth - 8;
      tagsNext.hidden = !overflow || atEnd;
      tags.classList.toggle('is-overflowing', overflow && !atEnd);
    };

    tagsNext.addEventListener('click', () => {
      tags.scrollBy({ left: Math.min(240, tags.clientWidth * 0.6), behavior: 'smooth' });
    });
    tags.addEventListener('scroll', updateTagsOverflow, { passive: true });
    window.addEventListener('resize', updateTagsOverflow);
    updateTagsOverflow();
  }

  const grid = root.querySelector('[data-powdi-blog-grid]');
  const loader = root.querySelector('[data-powdi-blog-loader]');
  if (!grid || !loader) return;

  let nextUrl = loader.dataset.nextUrl || '';
  let loading = false;

  const loadNext = async () => {
    if (loading || !nextUrl) return;
    loading = true;
    loader.dataset.loading = 'true';

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Blog page failed to load');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.querySelector('[data-powdi-blog-grid]');
      const nextLoader = doc.querySelector('[data-powdi-blog-loader]');

      if (nextGrid) {
        nextGrid.querySelectorAll(':scope > *').forEach((node) => {
          grid.appendChild(document.importNode(node, true));
        });
      }

      nextUrl = nextLoader?.getAttribute('data-next-url') || '';
      if (nextUrl) {
        loader.dataset.nextUrl = nextUrl;
      } else {
        loader.hidden = true;
        loader.dataset.nextUrl = '';
      }
    } catch (_error) {
      const fallback = nextUrl
        .replace(/([?&])section_id=[^&]*&?/g, '$1')
        .replace(/[?&]$/, '')
        .replace(/\?&/, '?');
      if (fallback) window.location.assign(fallback);
    } finally {
      loading = false;
      loader.dataset.loading = 'false';
    }
  };

  if (!nextUrl) {
    loader.hidden = true;
    return;
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadNext();
      },
      { rootMargin: '480px 0px' }
    );
    observer.observe(loader);
  }
})();
